<body class="end-outbound-scan-gle">
  <div class="end-outbound-scan-gle-container">
    <h3 class="page-title">{{ CONST.HEADER }}</h3>
    <ion-row>
      <!-- Icons -->
      <ion-col class="top-icons ion-no-padding action-btn-column">
        <app-filter-icon
          [isDisabled]="!isFilterEnabled"
          (clearFilterEvent)="clearAllFilters()"
        >
        </app-filter-icon>
        <app-excel-icon (exportExcelEvent)="exportExcel()"></app-excel-icon>
      </ion-col>
    </ion-row>
    <!-- Table -->
    <div class="end-outbound-scan-gle-table-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        id="excel-table"
        class="end-outbound-scan-gle-table"
      >
        <!-- MOVEMENT -->
        <ng-container matColumnDef="movement">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="parent-uld-headers"
            [ngClass]="{ 'movement-column-width-45': true }"
          >
            <app-table-search-component
              [columnName]="COLUMNTEXT.MOVEMENT"
              [control]="movementData.formControl"
              [maxLength]="10"
              [textInputWidth]="299"
              [searchIconOffset]="112"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="parent-uld-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.movement }}
          </td>
        </ng-container>

        <!-- CREATE_SORT_DATE -->
        <ng-container matColumnDef="departDate">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="departDate-headers"
            class="departDate"
            [ngClass]="{ 'depart-date-column-width-45': true }"
          >
            <ion-row class="th-text">{{ COLUMNTEXT.DEPART_DATE }}</ion-row>
            <div class="date-picker-container">
              <app-form-date-picker
                [icon]="SRC.CALENDAR"
                [formControl]="departDate.formControl"
                [maxDate]="maxDate"
                [minDate]="minDate"
                (valueChange)="search()"
              ></app-form-date-picker>
            </div>
          </th>

          <td
            headers="departDate-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.departDate | date: "mediumDate" }}
          </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="actions">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="action-headers"
            [ngClass]="{ 'action-column-width-10': true }"
          >
            <ion-row class="th-text"> {{ COLUMNTEXT.ACTIONS }} </ion-row>
            <div class="empty-item"></div>
          </th>
          <td
            mat-cell
            headers="action-headers"
            *matCellDef="let outboundScan; let i = index"
          >
            <ion-button
              fill="outline"
              class="edit-btn"
              (click)="action(outboundScan, i)"
            >
              {{ CONST.END }}
            </ion-button>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = dataIndex"
        ></tr>

        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell no-border no-results"
            [attr.colspan]="displayedColumns.length"
          >
            <app-no-results-found></app-no-results-found>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
